const pwaUpdateInProgressKey = "novinhub_pwa_update_in_progress";
const pwaUpdateFlag = "__novinhubPwaUpdateInProgress";

export function markPwaUpdateInProgress() {
  if (typeof window === "undefined") return;

  (window as any)[pwaUpdateFlag] = true;
  window.sessionStorage.setItem(pwaUpdateInProgressKey, "1");
}

export function clearPwaUpdateInProgress() {
  if (typeof window === "undefined") return;

  delete (window as any)[pwaUpdateFlag];
  window.sessionStorage.removeItem(pwaUpdateInProgressKey);
}

export function isPwaUpdateInProgress() {
  if (typeof window === "undefined") return false;

  return (
    (window as any)[pwaUpdateFlag] === true ||
    window.sessionStorage.getItem(pwaUpdateInProgressKey) === "1"
  );
}

export function reloadAfterPwaUpdate() {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  url.searchParams.delete("recovered_from_error");
  url.searchParams.delete("recovered_from_chunk");
  url.searchParams.set("pwa_updated_at", Date.now().toString());

  window.location.replace(url.toString());
}
